import styled from 'styled-components';
import { Box, BoxProps } from 'rebass/styled-components';
import theme from 'styled-theming';
import { layout } from 'styled-system';

const backgroundColor = theme('mode', {
  light: (props: any) => props.theme.colors.ghostDark,
  dark: (props: any) => props.theme.colors.cyanDarker,
});

const color = theme('mode', {
  light: (props: any) => props.theme.colors.quartz,
  dark: (props: any) => props.theme.colors.whiteGrey,
});

export const CardHeader = styled(Box)<BoxProps>`
  padding: 0px 24px;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : '')};
`;

export const CardBody = styled(Box)`
  padding: 24px;
`;

export const Card = styled(Box)`
  ${layout}
  border-radius: 6px;
  backdrop-filter: blur(8px);
  color: ${color};
  background-color: ${backgroundColor};
`;

export const CardBase = styled(Box)`
  color: ${color};
  background-color: ${backgroundColor};
  border-radius: 8px;
  position: relative;
  backdrop-filter: blur(8px);
  min-width: 250px;
`;
